import {
  ScheduledVisitAppointmentIconStylesProps,
  getScheduledVisitAppointmentIconStyles,
} from "./styles";

export const VisitConfirmedIcon = (
  props: ScheduledVisitAppointmentIconStylesProps,
) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={getScheduledVisitAppointmentIconStyles(props)}
    >
      <path
        d="M0.604004 8.39368C0.604004 3.9754 4.18573 0.393677 8.604 0.393677C13.0223 0.393677 16.604 3.9754 16.604 8.39368C16.604 12.812 13.0223 16.3937 8.604 16.3937C4.18573 16.3937 0.604004 12.812 0.604004 8.39368Z"
        fill="#ECFDF9"
      />
      <g clipPath="url(#clip0_892_18452)">
        <g clipPath="url(#clip1_892_18452)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.04393 0.4109C6.7086 0.502676 5.41173 0.933428 4.27674 1.66213C3.24943 2.3217 2.34309 3.26023 1.72386 4.30568C0.330534 6.65802 0.22951 9.54784 1.4554 11.9857C2.33492 13.7348 3.83924 15.1129 5.65193 15.8303C6.8986 16.3237 8.21217 16.4941 9.55593 16.3368C11.3275 16.1294 12.9866 15.3226 14.2598 14.0495C15.2383 13.0709 15.9263 11.895 16.3143 10.5377C16.4462 10.0761 16.5555 9.44075 16.5818 8.98168C16.5878 8.87829 16.5988 8.79368 16.6063 8.79368C16.6138 8.79368 16.6199 8.60605 16.6199 8.37674C16.6199 8.14743 16.6137 7.96362 16.6062 7.96829C16.5986 7.97296 16.5875 7.89599 16.5816 7.79724C16.5526 7.31808 16.4499 6.72954 16.3073 6.22568C15.4326 3.13516 12.8001 0.862068 9.62793 0.458212C9.14164 0.396308 8.5245 0.377876 8.04393 0.4109ZM8.10793 1.4114C7.1557 1.49178 6.36658 1.70487 5.53591 2.10591C4.14135 2.77917 2.98197 3.94282 2.30444 5.34927C1.95999 6.06429 1.74781 6.79551 1.64855 7.60968C1.60802 7.94218 1.60823 8.84813 1.64892 9.17768C1.73821 9.901 1.90001 10.5093 2.17372 11.151C2.82813 12.6853 4.06178 13.9762 5.55593 14.6903C6.30322 15.0474 6.97273 15.2416 7.82793 15.3491C8.14773 15.3893 9.06012 15.3893 9.37993 15.3491C10.2591 15.2385 10.9304 15.0407 11.6999 14.6652C13.1806 13.9427 14.3819 12.6762 15.0338 11.1504C15.3072 10.5105 15.4698 9.89968 15.5589 9.17768C15.5997 8.84773 15.5998 7.94196 15.5592 7.60968C15.3417 5.83021 14.5415 4.30565 13.2039 3.12247C12.3087 2.33055 11.1635 1.76719 9.96717 1.5302C9.50221 1.43808 9.25508 1.41476 8.69193 1.40981C8.41033 1.40733 8.14753 1.40805 8.10793 1.4114ZM12.4492 4.47032C12.3468 4.50693 12.2757 4.56032 12.1842 4.66932C12.1452 4.71572 10.9488 6.22776 9.52541 8.02941C7.15546 11.0292 6.93234 11.3067 6.87674 11.3233C6.7833 11.3513 6.71215 11.3207 6.63721 11.2203C6.60333 11.1748 6.22842 10.6445 5.80409 10.0417C5.37975 9.43888 5.00895 8.91668 4.98007 8.88122C4.89617 8.77818 4.78133 8.72487 4.62575 8.71669C4.51209 8.71072 4.48402 8.71496 4.40882 8.74938C4.21714 8.83714 4.12201 8.9769 4.11098 9.18695C4.10543 9.29266 4.11018 9.33016 4.13666 9.39002C4.16305 9.44967 5.55935 11.4509 5.85727 11.856C6.00783 12.0608 6.26386 12.2323 6.51933 12.2995C6.67561 12.3406 6.93183 12.3439 7.0902 12.3069C7.30479 12.2567 7.56269 12.1073 7.69609 11.9558C7.84669 11.7848 13.0194 5.22583 13.0516 5.16501C13.1028 5.06847 13.1136 4.9128 13.0777 4.78944C13.0053 4.54048 12.6945 4.38266 12.4492 4.47032ZM0.610918 8.39368C0.610918 8.62688 0.613158 8.72229 0.615878 8.60568C0.618614 8.48907 0.618614 8.29829 0.615878 8.18168C0.613158 8.06508 0.610918 8.16048 0.610918 8.39368Z"
            fill="#029C7B"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_892_18452">
          <path
            d="M0.604004 2.39368C0.604004 1.28911 1.49943 0.393677 2.604 0.393677H14.604C15.7086 0.393677 16.604 1.28911 16.604 2.39368V14.3937C16.604 15.4982 15.7086 16.3937 14.604 16.3937H2.604C1.49943 16.3937 0.604004 15.4982 0.604004 14.3937V2.39368Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_892_18452">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.604004 0.393677)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
